const covers = [
  {
    img: "/assets/svg/pages/drafts/cover/img1.svg",
    name: "Health Care",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img2.svg",
    name: "E-Commerce",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img3.svg",
    name: "Renewable Energy",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img4.svg",
    name: "FinTech",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img5.svg",
    name: "Entertainment & Streaming",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img6.svg",
    name: "Robotics",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img7.svg",
    name: "Construction",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img8.svg",
    name: "Food & Beverages",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img9.svg",
    name: "Gaming",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img10.svg",
    name: "EdTech",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img11.svg",
    name: "Sustainable Fashion",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img12.svg",
    name: "Tourism",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img13.svg",
    name: "TeleHealth",
  },
  {
    img: "/assets/svg/pages/drafts/cover/img111.svg",
    name: "Smart Cities",
  },
];

export default covers;
